import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-222b453f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "banner-background" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-background-overlay" }, null, -1))
const _hoisted_5 = { class: "banner-content" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "banner-content-text" }
const _hoisted_8 = { class: "banner-content-text-wrapper" }
const _hoisted_9 = { class: "banner-content-text-wrapper-subtitle" }
const _hoisted_10 = { class: "banner-content-text-wrapper-title" }
const _hoisted_11 = {
  key: 0,
  class: "banner-content-text-wrapper-title-name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require(`../assets/${_ctx.background}`),
        alt: "Banner Image"
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.subTitle), 1),
            _createElementVNode("h1", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
              (_ctx.titleName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.titleName), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}